import React, {FC} from "react";
import {Box, Card, CardContent, Grid, Typography} from "@material-ui/core";
import MultipleAutocomplete from "../components/MultipleAutocomplete";
import {FormikErrors, FormikTouched} from "formik";

type PropsType = {
  values: any
  a11yStandardsOptions: {value: string, display_name: string}[],
  languagesOptions: {value: string, display_name: string}[],
  setFieldValue: (field: string, value: any) => void,
  errors: FormikErrors<any>,
  touched: FormikTouched<any>
}

const CompanySupportsSection: FC<PropsType> = ({
  values,
  setFieldValue,
  a11yStandardsOptions,
  languagesOptions,
  errors,
  touched,
}) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" style={{ marginBottom: "20px" }}>
          3. Company supports
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Box>
              <MultipleAutocomplete
                value={values.supported_a11y_standards}
                label={'Supported a11y standards'}
                options={a11yStandardsOptions}
                onSetField={setFieldValue}
                field={'supported_a11y_standards'}
                error={!!errors.supported_a11y_standards && !!touched.supported_a11y_standards}
                helperText={errors.supported_a11y_standards}
              />
            </Box>
            <Box mt={5}>
              <MultipleAutocomplete
                value={values.supported_languages}
                label={'Supported languages'}
                options={languagesOptions}
                onSetField={setFieldValue}
                field={'supported_languages'}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default CompanySupportsSection